import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-qr-question',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './qr-question.component.html'
})
export class QrQuestionComponent {
  #route = inject(ActivatedRoute);
  #router = inject(Router);

  selectedType = signal<'prospect' | 'realtor' | null>(null);

  // Get salesOfficeId from route params or query params
  salesOfficeId = toSignal(this.#route.paramMap.pipe(map(params => params.get('salesOfficeId'))), {
    initialValue: null
  });

  salesOfficeIdFromQuery = toSignal(this.#route.queryParamMap.pipe(map(params => params.get('salesOfficeId'))), {
    initialValue: null
  });

  getSalesOfficeId(): string | null {
    return this.salesOfficeId() || this.salesOfficeIdFromQuery();
  }

  onSaveButtonClick(): void {
    const type = this.selectedType();
    if (!type) {
      return; // Don't submit if nothing is selected
    }

    const salesOfficeId = this.getSalesOfficeId();

    if (type === 'prospect') {
      if (salesOfficeId) {
        this.#router.navigate([`/new/${salesOfficeId}/prospect`]);
      } else {
        // Fallback to public route if no salesOfficeId
        this.#router.navigate([`/new/${salesOfficeId}/prospect`]);
      }
    } else if (type === 'realtor') {
      // Redirect to realtors page - can be customized later for public realtor registration
      if (salesOfficeId) {
        this.#router.navigate([`/new/${salesOfficeId}/realtor`]);
      } else {
        this.#router.navigate([`/new/${salesOfficeId}/realtor`]);
      }
    }
  }
}
